import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum SocialServiceMpsvRegionEnum {
    SOCIAL_SYSTEMS = 'socialSystems',
    LAW = 'law',
    PSYCHOLOGY = 'psychology',
    EDUCATION = 'education',
    OTHER = 'other',
}

export const socialServiceMpsvRegionEnumOptions = enumToOptions(SocialServiceMpsvRegionEnum, 'serviceType.region.mpsvRegion.');
